import script from "./insights-right-drawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./insights-right-drawer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__